import {BoxGeometry, Mesh} from "three";
import * as Globals from "../../globals";
import {toFixedFloat} from "../../utils/utils";
import {getVolume} from "../../utils/volumeUtils";
import {addEdgeGeometry} from "../../utils/threeUtils";
import {setObjectLayer} from "../../utils/layerUtils";
import {raehmSchwelleMaterial} from "../../constants/materialConstants";
import {raehmMeshName} from "../../constants/nameConstants";

export class Raehm {
    constructor(width, height, thickness, position) {
        let raehmGeometry = new BoxGeometry(width, thickness, height);
        let raehmMesh = new Mesh(raehmGeometry, raehmSchwelleMaterial);
        raehmMesh.position.copy(position);
        raehmMesh.name = raehmMeshName;
        let volume = toFixedFloat(getVolume(raehmMesh.geometry), 7);
        raehmMesh.userData.originalVolume = volume;
        raehmMesh.userData.sizedVolume = volume;
        raehmMesh.userData.width = width;
        raehmMesh.userData.height = height;
        raehmMesh.userData.depth = thickness;
        addEdgeGeometry(raehmMesh);
        setObjectLayer(raehmMesh, Globals.layers.raehm, true);
        return raehmMesh;
    }
}
